var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"homePage",attrs:{"fluid":""}},[_c('HomeSection'),_c('QuickFeatures'),_c('Services')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }